// extracted by mini-css-extract-plugin
export var bubble = "_2y-0";
export var container = "_2y-f";
export var contrastBorder = "_2y-g";
export var greyOut = "_2y-2";
export var initialsColor0 = "_2y-3";
export var initialsColor1 = "_2y-4";
export var initialsColor10 = "_2y-d";
export var initialsColor11 = "_2y-e";
export var initialsColor2 = "_2y-5";
export var initialsColor3 = "_2y-6";
export var initialsColor4 = "_2y-7";
export var initialsColor5 = "_2y-8";
export var initialsColor6 = "_2y-9";
export var initialsColor7 = "_2y-a";
export var initialsColor8 = "_2y-b";
export var initialsColor9 = "_2y-c";
export var initialsWrapper = "_2y-1";
export var large = "_2y-l";
export var medium = "_2y-k";
export var mediumSmall = "_2y-j";
export var mediumSmallMedium = "_2y-o";
export var micro = "_2y-h";
export var small = "_2y-i";
export var tiny = "_2y-n";
export var xTiny = "_2y-m";